import React from "react";

const products = [];
export default React.createContext(products);
